import { useNavigate } from 'react-router-dom';
import Badge from '@/components/base/Badge';
import { customerStatus } from '@/lib/statusDefs';

interface MobileCustomerHeaderProps {
  fullName: string;
  status: string;
  customerNo: string;
  createdAt: string;
  onMoreClick: () => void;
  hideBack?: boolean;
}

export default function MobileCustomerHeader({
  fullName,
  status,
  customerNo,
  createdAt,
  onMoreClick,
  hideBack = false,
}: MobileCustomerHeaderProps) {
  const navigate = useNavigate();

  return (
    <div className="lg:hidden w-full max-w-full overflow-hidden" style={{ paddingTop: 'calc(8px + env(safe-area-inset-top, 0px))' }}>
      {/* Row 1: Back + Name + More */}
      <div className="flex items-center gap-2 min-w-0">
        {!hideBack && (
          <button
            onClick={() => navigate('/customers')}
            className="w-9 h-9 rounded-lg hover:bg-background-100 flex items-center justify-center flex-shrink-0 cursor-pointer active:scale-95 transition-transform"
          >
            <i className="ri-arrow-left-line text-foreground-600 text-lg"></i>
          </button>
        )}
        <h1 className="flex-1 text-xl font-bold text-foreground-900 font-heading min-w-0 leading-tight line-clamp-2">
          {fullName}
        </h1>
        <button
          onClick={onMoreClick}
          className="w-9 h-9 rounded-lg hover:bg-background-100 flex items-center justify-center flex-shrink-0 cursor-pointer active:scale-95 transition-transform"
        >
          <i className="ri-more-2-fill text-foreground-500 text-lg"></i>
        </button>
      </div>

      {/* Row 2: Status + Customer No + Date */}
      <div className="flex items-center gap-2 mt-1.5 flex-wrap">
        <Badge badgeClass={customerStatus.badgeClass(status)} icon={customerStatus.icon(status)}>{status}</Badge>
        <span className="text-xs text-foreground-400">·</span>
        <span className="text-xs text-foreground-400">{customerNo}</span>
        <span className="text-xs text-foreground-300">·</span>
        <span className="text-xs text-foreground-400">{createdAt}</span>
      </div>
    </div>
  );
}